import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-modal-add-log',
  templateUrl: './modal-add-log.component.html',
  styleUrls: ['./modal-add-log.component.scss'],
})
export class ModalAddLogComponent implements OnInit {

  logMessage: string = "";

  constructor(public modalController: ModalController) { }

  ngOnInit() {}

  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'AddHistoryLogModal');
  }

  addHistoryLog()
  {
    var returnData = { logMessage: this.logMessage };
    this.modalController.dismiss(returnData, null, 'AddHistoryLogModal');
  }
}
